// tools
import { initClarity } from '@tools/clarity'

export default defineNuxtPlugin(() => {
  onNuxtReady(() => initClarity())
})